import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoEntry = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.66285 5.00008L7.51832 3.14461C7.60638 3.05671 7.65591 2.93742 7.65602 2.81299C7.65613 2.68857 7.60681 2.5692 7.5189 2.48114C7.431 2.39308 7.31171 2.34354 7.18729 2.34343C7.06286 2.34332 6.94349 2.39264 6.85543 2.48055L4.99996 4.33602L3.14449 2.48055C3.05643 2.39249 2.93699 2.34302 2.81246 2.34302C2.68792 2.34302 2.56849 2.39249 2.48043 2.48055C2.39237 2.56861 2.3429 2.68804 2.3429 2.81258C2.3429 2.93712 2.39237 3.05655 2.48043 3.14461L4.3359 5.00008L2.48043 6.85555C2.39237 6.94361 2.3429 7.06304 2.3429 7.18758C2.3429 7.31212 2.39237 7.43155 2.48043 7.51961C2.56849 7.60767 2.68792 7.65714 2.81246 7.65714C2.93699 7.65714 3.05643 7.60767 3.14449 7.51961L4.99996 5.66414L6.85543 7.51961C6.94349 7.60767 7.06292 7.65714 7.18746 7.65714C7.31199 7.65714 7.43143 7.60767 7.51949 7.51961C7.60755 7.43155 7.65702 7.31212 7.65702 7.18758C7.65702 7.06304 7.60755 6.94361 7.51949 6.85555L5.66285 5.00008Z",
		fill: "white"
	})
});
export default SvgNoEntry;
